// src/components/FloatingHelpButton.js
import React from 'react';
import '../styles/FloatingHelpButton.css';
import { FaEnvelope } from 'react-icons/fa'; // Mudei para um ícone de e-mail/contato

const FloatingHelpButton = () => {
  // --- Configure seu e-mail aqui ---
  const email = 'dev.gabrielmartielo@gmail.com'; // <-- TROQUE PELO E-MAIL REAL DO SEU PRIMO
  const subject = 'Solicitação de Ajuda Pelo Site - TR Victor Guincho';
  const body = 'Olá! Gostaria de solicitar ajuda ou fazer uma pergunta. \n\n[Escreva sua mensagem aqui]';

  // O código abaixo formata o assunto e o corpo do e-mail para a URL
  const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

  return (
    <a href={mailtoLink} className="floating-btn" title="Enviar um E-mail">
      <FaEnvelope />
    </a>
  );
}

export default FloatingHelpButton;